import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const nameStyle = { background: colors.WHITE, width: '40%' };

export default { nameStyle };
